import { createMessageBox, getUrlAction, inputIsValid, TestaCPF } from './utils'

export const usuario = {
  id: '',
  identificadorQRCode: '',
  logado: false,
  semCadastro: false,
  fotoPerfil: '',
  nome: '',
  telefone: '',
  dataNascimento: '',
  email: '',
  sexo: '',
  cpf: '',
  enderecos: [],
  enderecoPrincipal: '',
  enderecoSelecionado: '',
  tokenFirebase: '',
  cookies: {
    consentimentoMixpanel: '',
  },
  temSenha: false,
  cartoes: [],
}

export function alteraDadosUsuario(dados) {
  return new Promise((resolve, reject) => {
    axios
      .get(getUrlAction('cadastros', 'SetDadosUsuario'), {
        params: {
          ...dados,
        },
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function solicitaDadosUsuario(dados, afterSave) {
  let htmlDados = ``

  const userData = {
    ...usuario,
  }

  if (dados.cpf) {
    htmlDados += `     
        <div class="flex flex-column">
            <div class="font-12 m-12-0">CPF</div>
            <div class="input-wrapper">
                <input id="usuario-cpf" class="input" type="text" placeholder="CPF" value="${userData.cpf || ''}" required/>
            </div>
        </div>
        `
  }

  if (dados.email) {
    htmlDados += `     
        <div class="flex flex-column">
            <div class="font-12 m-12-0">Email</div>
            <div class="input-wrapper">
                <input id="usuario-email" class="input" type="email" placeholder="Email" value="${userData.email || ''}" required/>
            </div>
        </div>
        `
  }

  const messageBox = createMessageBox({
    content: `
        <div class="font-14 font-500">Para continuar com o pagamento via PIX, complete seu cadastro.</div>
        <div id="error-wrapper"></div>
        ${htmlDados}
        <div class="flex gap-8">
            <button id="btn-cancelar" class="btn-transparent w-100 m-t-16">Cancelar</button>
            <button id="btn-continuar" class="btn-azul w-100 m-t-16">Continuar</button>
        </div>
        `,
  })

  const btnCancelar = document.getElementById('btn-cancelar')
  btnCancelar.addEventListener('click', () => {
    messageBox.remove()
  })

  const inputCPF = document.getElementById('usuario-cpf')
  if (inputCPF) {
    IMask(inputCPF, {
      mask: '000.000.000-00',
      lazy: true,
    })
  }

  const inputEmail = document.getElementById('usuario-email')

  const btnContinuar = document.getElementById('btn-continuar')
  btnContinuar.addEventListener('click', () => {
    if (dados.cpf) {
      const valueAsString = inputCPF.value.toString()
      if (!TestaCPF(valueAsString)) {
        inputCPF.setCustomValidity('CPF inválido')
        inputCPF.reportValidity()
        return
      } else {
        usuario.cpf = valueAsString
      }
    }

    if (dados.email) {
      if (!inputIsValid(inputEmail)) {
        inputEmail.setCustomValidity('Preencha o campo de email')
        inputEmail.reportValidity()
        return
      } else {
        usuario.email = inputEmail.value
      }
    }

    salvaDadosUsuario().then((response) => {
      if (!response.lValid) {
        if (response.msg) {
          const errorWrapper = document.getElementById('error-wrapper')
          errorWrapper.innerHTML = `<div class="alert">${response.msg}</div>`
        }
      } else {
        messageBox.remove()
        afterSave && afterSave()
      }
    })
  })
}

function salvaDadosUsuario() {
  return new Promise((resolve, reject) => {
    axios
      .get(getUrlAction('cadastros', 'SetDadosUsuario'), {
        params: {
          telefone: usuario.telefone,
          sexo: usuario.sexo,
          cpf: usuario.cpf,
          dataNascimento: usuario.dataNascimento,
          email: usuario.email,
        },
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
